import React, { useEffect, useRef, useState } from "react";
import Header from "./Header";
import HeroImage from "./icons/HeroImage.png";
import profileIcon from "./icons/yellow.png";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import axios from "axios";
import { path, ENV } from "../../path";
import { useHistory } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { EventTypes, trackEvent } from "../../Utils/Analytics";

function LeaderBoard() {
  const [Participants, setParticipants] = useState([]);
  const [CommunityEarnings, setCommunityEarnings] = useState("");
  const [isEndOfList, setIsEndOfList] = useState(false);
  // const [loading, setLoading] = useState(false);
  const skipRef = useRef(0)
  const loadingRef = useRef(false);
  const scrollRef = useRef();
  const history = useHistory();

  const fetchParticipants = async () => {
    if (loadingRef.current || isEndOfList) {return;}

    loadingRef.current = true
    try {
      const response = await axios.get(
        `${path}/leaderboard?skip=${skipRef.current}&limit=20`
      );

      const newData = response.data.data || [];
      setParticipants((prev) => [...prev, ...newData]);

      if (newData.length < 1) {
        setIsEndOfList(true);
      } else {
        skipRef.current += 20;
      }
    } catch (error) {
      console.error("Error while fetching participants:", error);
      // Optional: Show user-facing error message
    } finally {
      loadingRef.current = false
    }
  };

  const getCommunityEarnings = async () => {
    try {
      const response = await axios.get(
        `${path}/leaderboard/getCommunityEarnings`
      );
      setCommunityEarnings(
        response.data.totalCommunityEarnings.toLocaleString("en-IN")
      );
    } catch (error) {
      console.log("Error in fetching community Earnings:", error);
    }
  };

  useEffect(() => {
    fetchParticipants(); // Initial load
    getCommunityEarnings();

    if(ENV === "prod"){
      trackEvent(EventTypes.PAGE_VIEW,{
        page:"leader-board"
      });
    }
  }, []);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) {return;}

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;
      if (scrollTop + clientHeight >= scrollHeight - 100) {
        fetchParticipants();
      }
    };

    scrollElement.addEventListener("scroll", handleScroll);
    return () => {
      scrollElement.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={scrollRef}
      className=" h-screen w-full fixed inset-0 overflow-y-scroll bg-slate-100 font-gilroy-regular">
      <Header />

      <div className="flex flex-col w-full px-4 py-2 mb-10 mx-auto md:max-w-lg">
        <div
          className=" flex item-center cursor-pointer "
          onClick={() => history.goBack()}>
          <ChevronLeftIcon className="text-gray-400" />
          <p className="text-lg text-gray-400  font-medium font-gilroy-semibold ">
            Go Back
          </p>
        </div>
        <div className=" relative flex items-center justify-center mx-auto bg-teal-500 w-full p-4  rounded-2xl">
          <div className="relative flex flex-col items-center justify-center rounded-xl p-4 z-10">
            <h1 className="text-2xl text-white font-semibold font-gilroy-semibold">
              {`INR ${CommunityEarnings}`}
            </h1>
            <p className=" text-lg text-white">Total Community Earnings</p>
          </div>
          <img
            src={HeroImage}
            alt="HeroImage"
            className="absolute w-full h-full"
          />
        </div>
        <h1 className=" text-xl font-semibold font-gilroy-semibold mt-2">
          Winners
        </h1>
        <div className="flex flex-col gap-2 ">
          {Participants?.length > 0 &&
            Participants?.map((item, index) => (
              <div
                key={item?._id}
                className="bg-white space-x-3 rounded-lg  p-3 flex flex-row items-center"
              >
                <div className="flex items-center justify-between gap-6 w-full">
                  {/* Rank Icon + Profile Image */}
                  <div className="flex items-center gap-2 shrink-0 min-w-fit">
                    {!([0, 1, 2].includes(index)) && (
                      <p className="text-sm">#{index + 1}</p>
                    )}
                    {[0, 1, 2].includes(index) && (
                      <WorkspacePremiumIcon
                        className="size-6"
                        style={{ color: ["gold", "silver", "#D97706"][index] }}
                      />
                    )}
                    <img
                      className="ml-3 w-12 h-12 bg-gray-200 rounded-lg object-cover shrink-0"
                      src={item?.profilePicture || profileIcon}
                      alt={item?.username}
                    />
                  </div>

                  {/* Username + Earnings + Stats */}
                  <div className="flex flex-col gap-2 flex-1 justify-start min-w-0">
                    {/* Username and Earnings */}
                    <div className="flex gap-2 justify-between items-center min-w-0">
                      <p className="text-lg font-medium font-gilroy-medium truncate w-[60%]">
                        {item?.username}
                      </p>
                      <p
                        className="text-lg font-medium font-gilroy-medium text-[#008080] text-nowrap"
                        style={{ fontFamily: "Gilroy-SemiBold" }}
                      >
                        {`INR ${item?.earnings} /-`}
                      </p>
                    </div>

                    {/* Competition Stats */}
                    <div className="flex flex-row items-center gap-2 text-gray-700">
                      <p
                        className="font-gilroy text-xs font-medium"
                        style={{ color: "#707C97" }}
                      >
                        {item?.competitionParticipated} Competition
                      </p>
                      <div className="w-1 h-1 rounded-full bg-gray-300" />
                      <p
                        className="font-gilroy text-xs font-medium"
                        style={{ color: "#707C97" }}
                      >
                        {item?.competitionWon} Wins
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            ))}
          {loadingRef.current && (
            <div className=" border-2 border-t-white border-teal-400 size-5 rounded-full animate-spin mx-auto" />
          )}
        </div>
      </div>
    </div>
  );
}

export default LeaderBoard;
